// Redux Actions
export const SET_MY_LISTS_FETCHING = 'SET_MY_LISTS_FETCHING'
export const SET_MY_LISTS = 'SET_MY_LISTS'
export const SET_ACTIVE_LIST_FETCHING = 'SET_ACTIVE_LIST_FETCHING'
export const SET_ACTIVE_LIST = 'SET_ACTIVE_LIST'
export const SET_ADDITIONAL_LISTS = 'SET_ADDITIONAL_LISTS'
export const SET_LIST_SEARCH_RESULTS = 'SET_LIST_SEARCH_RESULTS'
export const RESET_LIST_SEARCH_RESULTS = 'RESET_LIST_SEARCH_RESULTS'
export const TOGGLE_IS_REORDERING = 'TOGGLE_IS_REORDERING'
export const SET_REORDERED_LIST_ITEMS = 'SET_REORDERED_LIST_ITEMS'
export const RESET_LIST_REORDERING = 'RESET_LIST_REORDERING'

export const LIST_ITEMS_PAGE_LIMIT = 20

// Analytics
export const listsPageType = 'List'
export const listDetailPageType = 'List Detail Page'

// Page Titles
export const ListsPageTitle = {
  SAVED_ITEMS: 'Saved Items',
  FREE_TRIALS: 'Free Trials',
  PURCHASED_ITEMS: 'Purchased Items',
  MY_LISTS: 'My Lists',
}
